/**
 * 別アイコンファイル情報登録
 *
 * @export RegistCwsIconFileDataVo
 * @class RegistCwsIconFileDataVo
 */
export class RegistCwsIconFileDataVo {
    constructor(
        public iconCode: string,
        public startOrderCode: string,
        public endOrderCode: string,
        public iconAlternativeText: string,
    ) {}
}
